import { buildOrdersQueryString } from '@/helpers/ordersQueryParams'
import {
    fetchErrorOrdersData,
    fetchOrders,
    fetchStatuses,
} from '@/services/departmentService'
import { notificationService } from '@/utils/notifications'

export default {
    async fetchOrders({ commit, state }, { limit, offset, search = '' }) {
        const clearSearch = !search
            ? ''
            : search.trim().replace(/\+|\s|\(|\)/g, '')
        const param =
            clearSearch && clearSearch.length > 12 ? 'transaction_id' : 'phone'
        const query = !clearSearch
            ? ''
            : `&${param}=${
                  param === 'phone' ? clearSearch.replace('-', '') : clearSearch
              }`

        try {
            const response = await fetchOrders(
                limit,
                offset,
                buildOrdersQueryString(state.paramsSearch),
                query
            )

            if (response && response.data) {
                commit('ADD_TO_ORDERS', response.data.orders)
                commit('SET_COUNT', response.data.count)
            }
        } catch (error) {
            console.error('Failed to execute fetchOrders:', error)
            notificationService.showError(error)
            throw error
        }
    },

    async fetchStatuses({ state, commit }) {
        const displayedStatuses = [
            'waiting_start_cooking',
            'sent_to_division',
            'cooking',
            'completed',
            'canceled',
            'canceled_by_manager',
            'send_error',
        ]
        if (state.statuses.length !== 0) {
            return
        }

        try {
            const response = await fetchStatuses()

            if (response && response.data) {
                const filteredStatuses = response.data.filter(item =>
                    displayedStatuses.includes(item.id)
                )
                commit('ADD_TO_STATUSES', filteredStatuses)
            }
        } catch (error) {
            console.error('Failed to execute fetchStatuses:', error)
            notificationService.showError(error)
            throw error
        }
    },

    async fetchErrorOrdersData({ commit }) {
        try {
            const response = await fetchErrorOrdersData()
            commit('SET_ERROR_ORDERS_DATA', response.data)
        } catch (error) {
            console.error('Failed to execute fetchErrorOrdersData:', error)
            notificationService.showError(error)
            throw error
        }
    },
}
